module.exports = __webpack_public_path__ + "img/ES3115.5c46c882.png";